import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { ControlUser } from '../model/controlUser';
import { UserService } from '../service/user.service';
import { Log } from '../util/log';

@Component({
  selector: 'app-owners-list',
  templateUrl: './owners-list.component.html',
  styleUrls: ['./owners-list.component.css']
})
export class OwnersListComponent implements OnInit {

  @ViewChild('ownerslisttable', { static: true }) table;
  @ViewChild('ownerslistloader', { static: true }) loader;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  @Output() selected = new EventEmitter<ControlUser>();
  selectedOwner: ControlUser;
  selectedRow: number;

  dataSource: OwnersSource;

  displayedColumns: string[] = ['username', 'displayName', 'email' ];
  
  ownerList: ControlUser[];

  constructor(private userService: UserService, private cdRef:ChangeDetectorRef, private router: Router) { 

  }

  ngOnInit(): void {

  }

  ngAfterViewInit() {

    setTimeout(() => {
      this.loader.showLoading();
    });

    this.getOwnerList();
  }

  ngOnChanges(changes: SimpleChanges) {
    
  }

  getOwnerList() {

    Log.debug("getOwnerList");

    this.loader.showLoading();

    this.dataSource = new OwnersSource(this.userService);

      this.table.dataSource = this.dataSource;

      this.dataSource.ownersData.subscribe(data => {

        Log.debug("ownersData: " + data);

        setTimeout(() => {
          this.cdRef.detectChanges();
        });
        
      }, error => {

        this.loader.hideLoading();
        this.loader.showError();
      });

      setTimeout(() => {
        
        this.sort.sortChange.subscribe(v => Log.debug(v) )

        this.dataSource.isLoading.subscribe(isLoading => {

          if(!isLoading) {
            this.loader.hideLoading();
          }
        });
      });
  }

  addOwner() {

    this.router.navigate(['add-owner']);
  }

  onRowClicked(row) {

    Log.debug('clicked owner with id ' + row.id);

    this.selectedRow = row.id;

    this.selected.emit(row);
    this.selectedOwner = row;

    this.cdRef.detectChanges();
  }
}

export class OwnersSource extends MatTableDataSource<ControlUser> {

  isLoading = new BehaviorSubject(false);
  ownersData = new BehaviorSubject<ControlUser[]>([]);

  constructor(private userService: UserService) {
    super();

    // this.filterPredicate = function (data: DevicePilomat, filter: string): boolean {
    //   Log.debug("filter: " + filter);
    //   return false;
    // }
  }

  loadData() {

    this.isLoading.next(true);

    const obs = this.userService.getOwners();
    obs.subscribe(data => {

      this.isLoading.next(false);
      this.ownersData.next(data);
    });
  }

  connect(): BehaviorSubject<ControlUser[]> {

    this.loadData();
    return this.ownersData;
  }

  disconnect() {
  }
}